import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpResponse, HttpErrorResponse, HttpHandler, HttpEvent } from '@angular/common/http';
// import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import { User } from '../';
import { ToastController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class InterceptorProvider implements HttpInterceptor {
  forbiden: string;
  notAuth: string;
  constructor(private user: User, private toastCtrl: ToastController, public translateService: TranslateService) {
    this.translateService.get('ERROR_FORBIDEN', 'ERROR_AUTH').subscribe(value => {
      this.forbiden = value['ERROR_FORBIDEN'];
      this.notAuth = value['ERROR_AUTH'];
    });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (this.user.isLoggedIn()) {
      const user = this.user.user;
      const clonedreq = req.clone({
        headers: req.headers.set('Authorization', 'Bearer ' + user.token)
      });
      return next.handle(clonedreq).do(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) { }
        },
        (error: any) => {
          if (error instanceof HttpErrorResponse) {
            if (error.status === 401) {
              this.toastCtrl.create({ message: this.notAuth, duration: 4000, position: 'top' }).present();
              this.user.logout();
              // this.app.getRootNavs()[0].setRoot(FirstRunPage);
            } else if (error.status === 403) {
              this.toastCtrl.create({ message: this.forbiden, duration: 4000, position: 'top' }).present();
            } else if (error.status === 0) {
              this.user.logout();
              // this.app.getRootNavs()[0].setRoot(FirstRunPage);
            }
          }
        }
      );
    } else {
      this.user.logout();
      // this.app.getRootNavs()[0].setRoot(FirstRunPage);
    }
    return next.handle(req);
  }
}



// WEBPACK FOOTER //
// ./src/providers/interceptor/interceptor.ts